
import React from 'react'
import { renderToStaticMarkup } from 'react-dom/server'

import { warningIcon, errorIcon /* , downloadFileMessageIcon */ } from '../../../../components/icons'
import { TRANSCRIPT_API_TRANSCRIPTS } from '../../transcriptViewerSaga'
import saveFile from '../../../../libs/saveFile'

import { getFileType, getLinkTextFromServerText, getNameFromLinkText } from '../../../../_dependencies/js_chat_clients/module/dev/room/message-display-area/messages/models/file-message/utils.ts'
import DownloadButton from '../../../../_dependencies/js_chat_clients/module/dev/components/chat-tools-fool-componets/DownloadButton.tsx'

const CLASS_NAME_DOWNLOAD_FILE_LINK = 'download-file-link'
const CLASS_NAME_FILE_CANNOT_BE_DOWNLOADED = 'file-cannot-be-downloaded'

const fileLinkRegex = /<a href="\${FILE_TRANSFER_DOWNLOAD_ADDRESS}[^"]*"[^>]*>(.*?)<\/a>/g
const transformMessageTypeToText = type => type.replace('file', 'message')
const downloadButton = renderToStaticMarkup(<DownloadButton />)
const urlToDownloadFile =
  ({ transcriptId, messageId }) => `${TRANSCRIPT_API_TRANSCRIPTS}/${transcriptId}/${messageId}/download-file`
export const filesPresets = {
  available: {
    key: 'available',
    transformHtml: (html, title, fileName, transcriptId, messageId) => {
      const newAddress = urlToDownloadFile({ transcriptId, messageId })
      return html.replace(
        fileLinkRegex,
        (_ignore, linkText) => `<a
          href="${newAddress}|${fileName}"
          class="${CLASS_NAME_DOWNLOAD_FILE_LINK} not-media file-message-wraper"
          title="${title}"
        >
          <span class="file-message">${linkText}</span>
          <span class="download-btn">${downloadButton}</span>
        </a>`,
      )
    },
  },
  'file-size-exceeded': {
    key: 'file-size-exceeded',
    transformHtml: (html, title) => `<span class="${CLASS_NAME_FILE_CANNOT_BE_DOWNLOADED
    }" title="${title}">${warningIcon}${html}</span>`,
  },
  'room-total-size-exceeded': {
    key: 'room-total-size-exceeded',
    transformHtml: (html, title) => `<span class="${CLASS_NAME_FILE_CANNOT_BE_DOWNLOADED
    }" title="${title}">${warningIcon}${html}</span>`,

  },
  'saving-disabled': {
    key: 'saving-disabled',
    transformHtml: (html, title) => `<span class="${CLASS_NAME_FILE_CANNOT_BE_DOWNLOADED
    } error" title="${title}">${errorIcon}${html}</span>`,
  },
  'upload-blocked': {
    key: 'upload-blocked',
    transformHtml: (html, title) => `<span class="${CLASS_NAME_FILE_CANNOT_BE_DOWNLOADED
    } error" title="${title}">${errorIcon}${html}</span>`,
  },
  'saving-failed': {
    key: 'saving-failed',
    transformHtml: (html, title) => `<span class="${CLASS_NAME_FILE_CANNOT_BE_DOWNLOADED
    } error" title="${title}">${errorIcon}${html}</span>`,
  },
}
const isUnavailable = status => status !== 'available'

export function transformFileMessages({
  messages: oldMessages, transcriptId, texts, linksFromBlobByURL, urlsAlreadyDownloading, fileForPreviewStartDownload,
}) {
  const messages = JSON.parse(JSON.stringify(oldMessages))
  for (let ii = 0; ii < messages.length; ii++) {
    const { messageFile, text, messageId, messageType } = messages[ii]
    const isFileMessage = messageType.includes('file')
    if (!isFileMessage) continue

    /* OLD ************************** TODO: удалить когда не будет транскриптов старше 2026.04 */
    const isOld = !messageFile /* файл был создан до фичи что файлы сохраняются */
    if (isOld) {
      messages[ii].messageType = transformMessageTypeToText(messageType)
      messages[ii].text = text.replace(
        /<a(.{0,}">)/,
        '<a class="file-message-old" href="#" title="Only files sent starting April 9, 2026 are available for download">',
      )
      continue
    }

    /* UNAVAILABLE or NOT MEDIA************************** */
    const hrefMatch = text.match(/href="([^"]+)"/)
    const href = hrefMatch ? hrefMatch[1] : ''
    const isMedia = getFileType(href)
    if (isUnavailable(messageFile.status) || !isMedia) {
      messages[ii].messageType = transformMessageTypeToText(messageType)
      messages[ii].text = filesPresets[messageFile.status].transformHtml(
        text, texts[`file-message_title_${messageFile.status}`], messageFile.fileName, transcriptId, messageId,
      )
      continue
    }

    /* MEDIA ************************** */
    const url = urlToDownloadFile({ transcriptId, messageId })
    const linkFromBlobByURL = linksFromBlobByURL[url]
    if (linkFromBlobByURL) { /* show media preview */
      const linkText = getLinkTextFromServerText(text);
      const name = getNameFromLinkText(linkText);
      messages[ii].text = messages[ii].text.replace('href=', `download="${name}" href=`)
      messages[ii].text = messages[ii].text.replace(
        /\$\{FILE_TRANSFER_DOWNLOAD_ADDRESS\}/,
        `${linkFromBlobByURL}#`,
      )
    } else { /* download media preview */
      const urlAlreadyDownloading = urlsAlreadyDownloading[url]
      if (!urlAlreadyDownloading) {
        fileForPreviewStartDownload(url)
      }
      messages[ii].messageType = transformMessageTypeToText(messageType)
      messages[ii].text = `<span class="downloading-media-file-preview" title="${
        texts['file-message_title_loading']}">${messages[ii].text}</span>`
    }
  }
  return messages
}

export const tryDownloadFile = downloadFile => event => {
  let downloadFileLink = event.target.closest(`a.${CLASS_NAME_DOWNLOAD_FILE_LINK}`)
  if (!downloadFileLink) {
    const fileMessageWrapper = event.target.closest('div.file-message-wraper')
    if (!fileMessageWrapper) return
    downloadFileLink = fileMessageWrapper.getElementsByClassName(CLASS_NAME_DOWNLOAD_FILE_LINK)[0]
    if (!downloadFileLink) return
  }

  event.preventDefault();
  const href = downloadFileLink.getAttribute('href').split('?')[0]
  const [url, fileName] = href.split('|');
  downloadFile({
    url,
    onSuccess: blob => saveFile(fileName || 'file_from_transcript', blob),
  })
}
